import { render, staticRenderFns } from "./vip-list.vue?vue&type=template&id=20ab8314&"
import script from "./vip-list.vue?vue&type=script&lang=js&"
export * from "./vip-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports